import {createAction} from '@reduxjs/toolkit';

export const select = createAction('MOSAICS_SELECT');
export const compare = createAction('MOSAICS_COMPARE');
